"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * Soft navigation can leave homepage WebGL / motion UI behind (especially the
 * #technology section) when leaving a page that mounted the tech graph.
 * Force a clean scroll + strip any orphaned tech nodes after each route change.
 */
export function RouteChangeEffects() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.cursor = "";

    const isHome = /^\/(en|ro)\/?$/.test(pathname ?? "");
    document.querySelectorAll("#technology").forEach((node) => {
      if (isHome) {
        const main = document.querySelector("main");
        if (main && !main.contains(node)) node.remove();
        return;
      }
      node.remove();
    });
  }, [pathname]);

  return null;
}
